<template>

    <v-card>

        <v-card-title>{{ `${isNew ? 'New Network Device' : 'Edit Network Device'}` }}</v-card-title>

        <v-divider />

        <v-card-text style="max-height: calc(90vh - 200px); overflow-y: auto;">
            <v-form class="mt-4" ref="snmpForm" :lazy-validation="true" v-model="formValid">

                <v-row dense>
                    <v-col cols="12" md="10">
                        <v-text-field :disabled="!isNew" v-model="$props.networkDeviceClone.device" color="#c42111" label="Device" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.device, 'Device'), (!isNew || $store.state.validationFuncs.noDuplicates($props.networkDeviceClone.device, $props.existingDeviceNames))]" />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-switch class="mt-5" color="#c42111" v-model="enabled" @change="setDisableStatus" :label="enabled ? 'Enabled' : 'Disabled'" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="$props.networkDeviceClone.address" color="#c42111" label="Address" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.address, 'Address')]" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="$props.networkDeviceClone.port" type="number" min="1" step="1" color="#c42111" label="Port" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.port, 'Port'), $store.state.validationFuncs.positiveInteger($props.networkDeviceClone.port, 'Port')]" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-combobox v-model="$props.networkDeviceClone.protocol" :items="protocolOptions" color="#c42111" label="Protocol" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.protocol, 'Protocol')]" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="$props.networkDeviceClone.username" color="#c42111" label="Username" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.username, 'Username')]" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="$props.networkDeviceClone.password" color="#c42111" label="Password" :rules="[$store.state.validationFuncs.required($props.networkDeviceClone.password, 'Password')]" />
                    </v-col>
                </v-row>

                <v-row dense v-for="(setting, idx) in $props.networkDeviceClone.settings" :key="idx">
                        <v-col cols="12" md="5">
                            <v-combobox color="#c42111" v-model="setting.key" :items="settingKeyOptions" label="Key" :rules="[$store.state.validationFuncs.required(setting.key, 'Key'), $store.state.validationFuncs.noDuplicates(setting.key, existingKeyNames)]" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="setting.value" color="#c42111" label="Value" :rules="[$store.state.validationFuncs.required(setting.value, 'Value')]" />
                        </v-col>
                        <v-col cols="1" style="text-align: center;">
                            <v-btn style="margin-top: 15px;" width="40" min-width="40" color="#c42111" @click="deleteSetting(setting)"><v-icon>mdi mdi-delete-forever</v-icon></v-btn>
                        </v-col>
                </v-row>
                <v-col cols="12">
                    <v-btn color="#c42111" @click="addNewSetting">Add Key/Value</v-btn>
                </v-col>

            </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn @click="$emit('cancel')" text>Cancel</v-btn>
            <v-btn @click="saveClicked" text>Save</v-btn>
        </v-card-actions>

    </v-card>
    
</template>

<script>
export default {
    name: 'NetworkDeviceEdit',
    props: ['networkDeviceClone', 'existingDeviceNames'],
    components: {

    },
    data: () => ({
        formValid: true,
        protocolOptions: ['ftp', 'sftp'],
        settingKeyOptions: [
            'performance_directories',
            'performance_files',
            'office',
            'srcdir',
            'pattern',
            'destdir',
            'office',
            'ftp_mtime_max_days_old',
            'ftp_mtime_max_days_old',
            'ftp_wait_secs_after_mtime',
            'ftp_no_transfer_warning',
            'local_directory',
            'ftp_dir_max_days_old',
            'local_file_name',
            'rmsrcfile',
            'db_loaded_office',
            'check_recursively',
            'prepend_office',
            'include_path_in_local',
            'include_office_in_local',
            'ignore_performance_dirs',
            'performance_local_file_name',
            'performance_remove_source_file'
        ],
        enabled: true
    }),

    computed: {
        isNew() {
            return !this.$props.networkDeviceClone.changed_by;
        },

        existingKeyNames() {
            return this.$props.networkDeviceClone.settings.map(s => s.key).filter((item, index, arr) => arr.indexOf(item) !== index);
        }
    },

    methods: {
        addNewSetting: function() {
            this.$props.networkDeviceClone.settings.push({
                key: '',
                value: ''
            });
        },

        deleteSetting: function(setting) {
            this.$props.networkDeviceClone.settings.splice(this.$props.networkDeviceClone.settings.indexOf(setting), 1);
        },

        saveClicked: function() {
            if(this.$refs.snmpForm.validate()) {
                this.$emit('save');
            }
        },

        setDisableStatus: function(value) {
            this.$props.networkDeviceClone.data.disabled = !value;
        }
    },

    created() {
        if(this.$props.networkDeviceClone.data.disabled === undefined || this.$props.networkDeviceClone.data.disabled == false) {
            this.enabled = true;
        }
        else {
            this.enabled = false;
        }
    },

    mounted() {
        
    }

};
</script>
